module.exports = __webpack_public_path__ + "img/ledgers.closed.monthly.5e997431.png";